import { identify } from './AnalyticsService.js'

export const GOOGLE_PLACES_DATA_SOURCE = 'Google Places'
export const CLEARBIT_DATA_SOURCE = 'Clearbit'
export const INVOICE_PAID_NOTIFICATION = 'invoice paid notification'

export function identifyWithDataSources(data_sources) {
  return identify({ data_sources: data_sources })
}

export function identifyWithPermissions(permissionEnabled, permissionType, category) {
  return identify({ permissions_enabled: permissionEnabled, permissions_type: permissionType, permission_category: category })
}

export function identifyWithPlanInterestedIn(planInterestedIn) {
  return identify({ plan_interested_in: planInterestedIn })
}
